<div 
  class="fixed bottom-5 right-5 flex items-center bg-white rounded-lg shadow-lg p-3 transition-all duration-300 z-50"
  [ngClass]="{'translate-y-24': !isActive || highlightItems.length === 0}">
  
  <!-- İstatistik ve sayı bilgisi -->
  <div class="flex items-center mr-3 text-gray-700 font-medium">
    <span class="flex items-center justify-center h-7 min-w-7 rounded-full bg-blue-100 text-blue-600 text-sm mr-2" *ngIf="highlightItems.length > 0">
      {{ currentIndex + 1 }}/{{ highlightItems.length }}
    </span>
    <span class="text-sm" *ngIf="highlightItems.length === 0">Sonuç bulunamadı</span>
  </div>
  
  <!-- Navigasyon butonları -->
  <div class="flex items-center space-x-2 mr-3">
    <button 
      class="w-8 h-8 rounded bg-gray-100 hover:bg-gray-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      (click)="previousHighlight()" 
      [disabled]="highlightItems.length <= 1"
      title="Önceki sonuç">
      <fa-icon [icon]="['fas', 'chevron-up']" class="text-gray-700"></fa-icon>
    </button>
    
    <button 
      class="w-8 h-8 rounded bg-gray-100 hover:bg-gray-200 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      (click)="nextHighlight()" 
      [disabled]="highlightItems.length <= 1"
      title="Sonraki sonuç">
      <fa-icon [icon]="['fas', 'chevron-down']" class="text-gray-700"></fa-icon>
    </button>
  </div>
  
  <!-- Gösterim seçenekleri -->
  <div class="border-l border-gray-200 pl-3 mr-3">
    <button 
      class="flex items-center text-xs text-gray-700 hover:text-blue-600 transition-colors py-1 px-2 rounded hover:bg-gray-50"
      (click)="toggleShowOnlyMatched()"
      [ngClass]="{'text-blue-600 font-medium': showOnlyMatched}">
      <fa-icon [icon]="['fas', showOnlyMatched ? 'check-square' : 'square']" class="mr-1"></fa-icon>
      Sadece eşleşen kelime
    </button>
  </div>
  
  <!-- Kapat butonu -->
  <button 
    class="w-8 h-8 rounded hover:bg-gray-100 flex items-center justify-center focus:outline-none text-gray-500 hover:text-gray-700 transition-colors"
    (click)="closeHighlights()" 
    title="Vurgulamayı kapat">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </button>
</div>
